/* PhotoSwipe enhances Dawn image buttons; Dawn remains the loading/error fallback. */
const loader = document.querySelector('script[data-am-gallery]');
let active;
if (loader?.dataset.core) {
  import(loader.dataset.core).then(({ default: PhotoSwipe }) => {
    document.addEventListener('click', (event) => {
      const button = event.target.closest?.('.am-product-page media-gallery .product__modal-opener--image button[data-am-zoom-src]');
      if (!button || event.defaultPrevented || event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) return;
      const gallery = button.closest('media-gallery');
      const buttons = [...gallery.querySelectorAll('.product__modal-opener--image button[data-am-zoom-src]')]
        .filter((item) => item.getClientRects().length > 0);
      const index = buttons.indexOf(button);
      if (index < 0 || active) return;
      const dataSource = buttons.map((item) => {
        const image = item.closest('modal-opener').querySelector('img');
        const width = Number(item.dataset.amZoomWidth);
        const height = Number(item.dataset.amZoomHeight);
        const scale = Math.min(1, 3000 / Math.max(width, height));
        return {
          src: item.dataset.amZoomSrc,
          width: Math.round(width * scale), height: Math.round(height * scale),
          alt: image?.alt || '', msrc: image?.currentSrc || image?.src,
        };
      });
      if (dataSource.some((item) => !item.width || !item.height)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      active = new PhotoSwipe({
        dataSource, index, mainClass: 'am-pswp', bgOpacity: 1,
        showHideAnimationType: reducedMotion ? 'none' : 'fade',
        showAnimationDuration: 180, hideAnimationDuration: 180,
        wheelToZoom: true, returnFocus: false,
        closeTitle: 'Close gallery', zoomTitle: 'Zoom image',
        arrowPrevTitle: 'Previous image', arrowNextTitle: 'Next image',
        errorMsg: 'This image could not be loaded. Please close the gallery and try again.',
      });
      active.on('destroy', () => {
        active = undefined;
        if (button.isConnected) button.focus({ preventScroll: true });
      });
      active.init();
    }, true);
    document.addEventListener('shopify:section:unload', () => active?.close());
    document.addEventListener('shopify:section:load', () => active?.close());
  }).catch(() => { /* Preserve the original Dawn modal if the module cannot load. */ });
}
